import { EmptyState } from '@components/molecules/empty-state';
import {
  dateFormat,
  defaultParams,
  pageSizeOptions,
  roleType,
  showSizeChanger,
  dateTimeFormat,
  paymentMethod,
} from '@utils/constants';
import { ICashFlow, ICoa } from '@interfaces/icash-flow';
import { IMeta } from '@interfaces/imeta';
import { getModule } from '@utils/request-api';
import { currencyCase } from '@utils/string-case';
import { filter, tableChangeParams } from '@utils/table';
import { formatTime } from '@utils/time';
import { Button, Divider, Popconfirm, Table } from 'antd';
import { PaginationConfig } from 'antd/lib/table';
import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';

interface IProps {
  isFetching: boolean;
  fetchDataSource: (params: any, isDetail: boolean) => void;
  deleteData: (code: string) => void;
  dataSource?: any;
  meta: IMeta;
}

interface IState {
  tableParams: any;
}

export class TableComponent extends Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      tableParams: defaultParams,
    };
  }
  public componentDidMount = () => {
    const { fetchDataSource } = this.props;
    const { tableParams } = this.state;
    fetchDataSource(tableParams, false);
  };
  public onChangeTable = (pagination: PaginationConfig, filters: any, sorter: any) => {
    const { fetchDataSource } = this.props;
    const { tableParams } = this.state;

    const params = tableChangeParams(pagination, filters, sorter, tableParams);
    this.setState({ tableParams: params });
    fetchDataSource(params, false);
  };
  public handleDeleteData = (code: string) => {
    const { fetchDataSource, deleteData } = this.props;
    const { tableParams } = this.state;
    deleteData(code);
    fetchDataSource(tableParams, false);
  };
  public render() {
    const { dataSource, isFetching, meta } = this.props;
    const tableEmptyState = <EmptyState emptyText="Data Tidak Ditemukan" />;

    const columns: any = [
      {
        title: 'Kode Cash Flow',
        dataIndex: 'code',
        ...filter('code'),
        sorter: true,
        render: (text: string, record: ICashFlow) => (
          <Link to={`/cash-flow/detail/${record.code}`}>{text}</Link>
        ),
        fixed: 'left',
        width: 180,
      },
      {
        title: 'No Daftar Muatan',
        dataIndex: 'dmCode',
        ...filter('dmCode'),
        sorter: true,
        render: (text: string) =>
          text ? <Link to={`/daftar-muatan/detail/${text}`}>{text}</Link> : '-',
        width: 200,
      },
      {
        title: 'Kode Voucher',
        dataIndex: 'voucherNo',
        ...filter('voucherNo'),
        sorter: true,
        render: (text: string) => text || '-',
        width: 180,
      },
      {
        title: 'Tanggal Pembayaran',
        dataIndex: 'paymentDate',
        ...filter('paymentDate'),
        sorter: true,
        render: (text: any) => (text ? formatTime(text, dateFormat) : '-'),
        width: 210,
      },
      {
        title: 'Tanggal Posting',
        dataIndex: 'postingDate',
        ...filter('postingDate'),
        sorter: true,
        render: (text: any) => (text ? formatTime(text, dateFormat) : '-'),
        width: 180,
      },
      {
        title: 'COA',
        dataIndex: 'coa',
        ...filter('coa'),
        render: (item: ICoa) => (item ? item.accountName : '-'),
      },
      {
        title: 'Saldo Normal',
        dataIndex: 'coa.normalBalance',
        render: (text: string) => (text ? (text === 'K' ? 'Kredit' : 'Debit') : '-'),
      },
      {
        title: 'Total',
        dataIndex: 'total',
        sorter: true,
        render: (text: any) => currencyCase(text),
      },
      {
        title: 'Metode Pembayaran',
        dataIndex: 'paymentMethod',
        ...filter('paymentMethod'),
        sorter: true,
        render: (text: number) => paymentMethod[text],
      },
      {
        title: 'Penerima Pembayaran',
        dataIndex: 'paymentReceiver',
        ...filter('paymentReceiver'),
        render: (text: string) => text || '-',
      },
      {
        title: 'Kassa',
        dataIndex: 'created_by',
        ...filter('created_by'),
        sorter: true,
        render: (text: string) => text || '-',
        width: 200,
      },
      {
        title: 'Diupdate Oleh',
        dataIndex: 'updated_by',
        ...filter('updated_by'),
        sorter: true,
        render: (text: string) => text || '-',
        width: 200,
      },
      {
        title: 'Diupdate Pada',
        dataIndex: 'updated_at',
        ...filter('updated_at'),
        sorter: true,
        render: (text: any) => (text ? formatTime(text, dateTimeFormat) : '-'),
        width: 200,
      },
      {
        title: 'Action',
        render: (text: any, record: ICashFlow) => (
          <Fragment>
            <Link to={`/cash-flow/form/${record.code}`}>Ubah</Link>
            {getModule(roleType.DIR) && (
              <Fragment>
                <Divider type="vertical" />
                <Popconfirm
                  title="Apakah Anda yakin untuk menghapus cash flow ini?"
                  onConfirm={() => record.code && this.handleDeleteData(record.code)}
                  okText="Iya"
                  cancelText="Tidak"
                >
                  <Button type="link">Hapus</Button>
                </Popconfirm>
              </Fragment>
            )}
          </Fragment>
        ),
        width: 200,
      },
    ];

    return (
      <div className="bt-table">
        <Table
          size="small"
          onChange={this.onChangeTable}
          columns={columns}
          dataSource={dataSource}
          bordered={true}
          pagination={
            meta && {
              current: meta.current_page,
              pageSize: meta.per_page,
              pageSizeOptions,
              showSizeChanger,
              total: meta.total,
            }
          }
          locale={{
            emptyText: tableEmptyState,
          }}
          loading={isFetching}
          scroll={{ x: 2800 }}
          rowKey="id"
        />
      </div>
    );
  }
}

export default TableComponent;
